export default __webpack_public_path__ + "static/dan-logo-white-d842ff71e85277152fcdf77137bc9745.png";